import '../styles/LandingHero.css';
import React from 'react';

function HeroDiagramBlock() {
  return (
    <div className="lh-block" aria-hidden="true">
      <div className="lh-block-meta">
        <span>Web</span>
        <span>Lead</span>
      </div>
      <svg
        className="lh-figure"
        viewBox="0 0 380 300"
        role="presentation"
        focusable="false"
      >
        {/* Layer 1: web */}
        <g className="lh-seq lh-seq-1">
          <path className="lh-str" d="M92 124 L42 58" />
          <path className="lh-str" d="M92 124 L46 150" />
          <path className="lh-str" d="M92 124 L92 182" />
          <path className="lh-str" d="M92 124 L140 150" />
          <path className="lh-str" d="M92 124 L142 58" />
        </g>
        <g className="lh-seq lh-seq-2">
          <path className="lh-str" d="M92 44 C56 46 38 72 38 100 C38 134 60 160 92 160 C124 160 146 134 146 100 C146 72 128 46 92 44 Z" />
          <path className="lh-str" d="M62 56 Q40 100 64 144" />
          <path className="lh-str" d="M122 56 Q144 100 120 144" />
          <path className="lh-str" d="M42 82 Q92 104 142 82" />
          <path className="lh-str" d="M40 118 Q92 96 144 118" />
          <path className="lh-str" d="M68 128 Q94 136 116 128" />
          <circle className="lh-spider" cx="92" cy="118" r="5.5" />
        </g>

        {/* Layer 3: connecting thread */}
        <g className="lh-seq lh-seq-3">
          <path
            className="lh-str"
            strokeDasharray="3 4"
            d="M148 118 C190 112 200 96 224 100"
          />
          <path className="lh-str" d="M214 94 L226 100 L216 106" />
          <text x="176" y="84">extracted</text>
        </g>

        {/* Layer 4: envelope */}
        <g className="lh-seq lh-seq-4">
          <rect className="lh-fill" x="224" y="70" width="120" height="80" rx="3" />
          <rect className="lh-str" x="224" y="70" width="120" height="80" rx="3" />
          <path className="lh-str" d="M224 72 L284 116 L344 72" />
          <path className="lh-str" d="M226 148 L274 110" />
          <path className="lh-str" d="M342 148 L294 110" />
          <circle className="lh-str" cx="284" cy="124" r="2" />
          <path className="lh-str" d="M272 124 L296 124" strokeDasharray="2 3" />
        </g>

        {/* Baseline rule + stamp */}
        <g className="lh-seq lh-seq-4">
          <path className="lh-str" d="M30 206 L350 206" opacity="0.55" />
          <path className="lh-str" d="M30 206 L30 200" />
          <path className="lh-str" d="M350 206 L350 200" />
          <text className="lh-stamp" x="30" y="236">dbaseextractor</text>
          <text x="246" y="236">one address at a time</text>
        </g>
      </svg>
    </div>
  );
}

function LandingHero() {
  return (
    <section className="lh-root" aria-labelledby="lh-headline">
      <div className="lh-rail" data-content-rail="primary">
        <div className="lh-copy">
          <p className="lh-kicker">
            <svg
              className="lh-kicker-mark"
              viewBox="0 0 34 12"
              fill="none"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M1 9 C6 3 10 3 14 7 C18 11 22 11 26 5 C28 2 31 2 33 4"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
              />
            </svg>
            dbaseextractor
          </p>
          <h1 className="lh-headline" id="lh-headline">
            Crawl the web. Extract the <em>email</em>.
          </h1>
          <p className="lh-lede">
            dbaseextractor crawls web pages and web directories to find and
            extract email leads, and keeps each one in a list you can return to.
          </p>
        </div>

        <div className="lh-actions">
          <a className="lh-cta" href="/sign-up">
            <span>Create your account</span>
            <svg
              className="lh-cta-arrow"
              viewBox="0 0 22 22"
              fill="none"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M3 11 H19 M13 5 L19 11 L13 17"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a className="lh-login" href="/login">
            Already have an account? Log in
          </a>
        </div>

        <HeroDiagramBlock />
      </div>
    </section>
  );
}

export default LandingHero;